<h1 i18n>Reset password</h1>

<p i18n>Enter your new password below to change your password.</p>

<form [formGroup]="form" (ngSubmit)="submit()">
    <div>
        <label for="password1" class="form-label" i18n>New password</label>
        <input
            type="password"
            id="password1"
            class="form-control"
            [class.is-invalid]="
                form.controls.new_password1.touched &&
                form.controls.new_password1.invalid
            "
            [formControl]="form.controls.new_password1"
        />
        @for (error of password1Errors$ | async; track $index) {
        <p class="invalid-feedback">
            {{ error }}
        </p>
        }
    </div>
    <div>
        <label for="password2" class="form-label" i18n>
            Repeat your new password
        </label>
        <input
            type="password"
            id="password2"
            class="form-control"
            [class.is-invalid]="
                form.controls.new_password2.touched &&
                form.controls.new_password2.invalid
            "
            [formControl]="form.controls.new_password2"
        />
        @for (error of password2Errors$ | async; track $index) {
        <p class="invalid-feedback">
            {{ error }}
        </p>
        }
    </div>
    @for (error of formErrors$ | async; track $index) {
    <p class="invalid-feedback always-block">
        {{ error }}
    </p>
    }
    <button type="submit" class="btn btn-primary my-3">
        <span i18n>Submit</span>
        @if (loading$ | async) {
        <div class="spinner-border spinner-border-sm ms-1" role="status">
            <span class="visually-hidden" i18n>Updating password...</span>
        </div>
        }
    </button>
</form>
